import React from 'react'
import PictureURL from '../static/default_picture_RM.jpg'

export default () => (
  <img src={PictureURL} alt="Richard Mille - default picture" />
)


// WEBPACK FOOTER //
// ./src/components/DefaultPicture.js